import { Controller } from "@hotwired/stimulus"

// Live countdown to an absolute end time (ISO 8601).
// Example: data-countdown-ends-at-value="2026-07-17T02:00:00Z"
export default class extends Controller {
  static values = {
    endsAt: String,
    prefix: { type: String, default: "" },
    endedLabel: { type: String, default: "ended" }
  }

  connect() {
    this.tick()
    this.timer = window.setInterval(() => this.tick(), 1000)
  }

  disconnect() {
    if (this.timer) window.clearInterval(this.timer)
  }

  tick() {
    const endMs = Date.parse(this.endsAtValue)
    if (Number.isNaN(endMs)) return

    const remainingMs = endMs - Date.now()
    if (remainingMs <= 0) {
      this.element.textContent = `${this.prefixValue}${this.endedLabelValue}`.trim()
      if (this.timer) window.clearInterval(this.timer)
      return
    }

    this.element.textContent = `${this.prefixValue}${this.format(remainingMs)}`.trim()
  }

  format(ms) {
    const totalSeconds = Math.floor(ms / 1000)
    const days = Math.floor(totalSeconds / 86400)
    const hours = Math.floor((totalSeconds % 86400) / 3600)
    const minutes = Math.floor((totalSeconds % 3600) / 60)
    const seconds = totalSeconds % 60

    if (days > 0) {
      return `${days}d ${hours}h ${minutes}m ${seconds}s`
    }
    if (hours > 0) {
      return `${hours}h ${minutes}m ${seconds}s`
    }
    return `${minutes}m ${seconds}s`
  }
}
